import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffChangePasswordModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "StaffChangePasswordModalContainer" */
      './StaffChangePasswordModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
